export default __webpack_public_path__ + "static/media/twitter.8ee267e8.svg";